document.addEventListener('turbolinks:load', () => {
    const guestSelfGuidedStartScreenPreview = document.getElementById('guestSelfGuidedStartScreenPreview')
    const sgScreen = document.getElementById('sgScreen')
    const startButton = document.getElementById('startButton')

    if (guestSelfGuidedStartScreenPreview !== null && sgScreen !== null && startButton != null) {
        resize()
    }

    function resize() {
        let resizeObserver = new ResizeObserver(() => {
            const currentSgScreenHeight = sgScreen.getBoundingClientRect().height

            if (startButton.classList.contains('text-lg2')) {
                startButton.style.fontSize = `${currentSgScreenHeight / 39}px`
                startButton.style.lineHeight = `${currentSgScreenHeight / 39}px`
            }
        })
        resizeObserver.observe(sgScreen);
    }
})